export function slugify(value) {
    return value
        .filter(Boolean)
        .map((value) => value?.trim().toLowerCase())
        .join("_")
        .replace(/-/gi, "_")
        .replace(/\s/gi, "_")
        .replace(/æ/gi, "ae")
        .replace(/ø/gi, "o")
        .replace(/å/gi, "a")
        .replace(/\W/gi, "")
        .replace(/_/gi, "-")
        .replace(/-+/gi, "-")
        .toLowerCase();
}
export function getBookSlug({ title, sku, authors, }) {
    const authorSlug = authors.length <= 2 ? slugify(authors) : "";
    return slugify([title, authorSlug, sku]);
}
export function getSkuFromBookSlug(slug) {
    return {
        sku: slug
            .split("-")
            .slice(-1)
            .find((sku) => !Number.isNaN(Number(sku))) ?? null,
    };
}
export function getSubscriptionSlug({ sku }) {
    return slugify(sku.split("-"));
}
export function getSkuFromSubscriptionSlug(slug) {
    return { sku: slug };
}
export function getContributorSlug({ name, scid, }) {
    return slugify([name, String(scid)]);
}
export function getContributorIdFromSlug(slug) {
    return {
        scid: slug
            .split("-")
            .slice(-1)
            .find((sku) => !Number.isNaN(Number(sku))) ?? null,
    };
}
